import { supabase } from '../../config/supabase';

const BUCKET = 'client-portal-uploads';

/**
 * Upload a file to the client portal bucket.
 * Path: {clientProfileId}/{clientProductId}/{filename}
 * @param {File} file
 * @param {string} clientProfileId
 * @param {string} clientProductId
 * @param {string} [customName] - optional filename override
 * @returns {Promise<{ success: boolean, path?: string, error?: string }>}
 */
export async function uploadVendrFile(file, clientProfileId, clientProductId, customName = null) {
  const name = customName || `${Date.now()}-${file.name.replace(/[^a-zA-Z0-9.-]/g, '_')}`;
  const path = `${clientProfileId}/${clientProductId}/${name}`;

  const { data, error } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, {
      cacheControl: '3600',
      upsert: true,
    });

  if (error) {
    return { success: false, error: error.message };
  }
  return { success: true, path: data.path };
}

/**
 * Get a signed URL for viewing a private file (e.g. in admin email or client view).
 * Prefer using this from an Edge Function for admin emails; from client, only for own files.
 * @param {string} path - full path in bucket
 * @param {number} [expiresIn=3600] - seconds
 */
export async function getSignedUrl(path, expiresIn = 3600) {
  const { data, error } = await supabase.storage.from(BUCKET).createSignedUrl(path, expiresIn);
  if (error) return { success: false, error: error.message };
  return { success: true, url: data.signedUrl };
}

/**
 * Remove a file from the bucket.
 */
export async function deleteVendrFile(path) {
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) return { success: false, error: error.message };
  return { success: true };
}
